var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningAmber24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning_amber_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/alert/warning_amber_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833008 17.5001L9.99967 1.66675L19.1663 17.5001H0.833008ZM16.2747 15.8334L9.99967 4.99175L3.72467 15.8334H16.2747ZM9.16634 13.3334V15.0001H10.833V13.3334H9.16634ZM9.16634 8.33341H10.833V11.6667H9.16634V8.33341Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAmber24Px);
export default __webpack_public_path__ + "static/media/warning_amber_24px.c1edc268650726ad4dc7347368699624.svg";
export { ForwardRef as ReactComponent };